module.exports = __webpack_public_path__ + "static/media/crocks_black.70c52d3c.jpg";